import { useCallback } from 'react';
import type { Nilable } from '~/utilities/type-guards';
import type { OnboardingActivityAction, OnboardingActivityEnum } from '~/graphql';
import { useCreateOnboardingActivityMutation } from './__gql/createOnboardingActivity.gql.gen';
import { getUniqueFeatureId } from '../utils/getUniqueFeatureId';
import type { SupportedFeatureIds } from '../types';
import type { SupportedNudgeFeatureIds } from '../nudges/types';

export const useCreateOnboardingActivityService = (): ((
  action: OnboardingActivityAction,
  featureId: SupportedFeatureIds | SupportedNudgeFeatureIds,
  activityType: OnboardingActivityEnum,
) => Promise<
  Nilable<{
    id: string;
    action: OnboardingActivityAction;
    featureId: string;
  }>
>) => {
  const [createOnboardingActivity] = useCreateOnboardingActivityMutation();

  return useCallback(
    async (
      action: OnboardingActivityAction,
      featureId: SupportedFeatureIds | SupportedNudgeFeatureIds,
      activityType: OnboardingActivityEnum = 'onboarding',
    ) => {
      const { data } = await createOnboardingActivity({
        variables: {
          input: {
            action,
            activityType,
            featureId: getUniqueFeatureId(featureId),
          },
        },
      });

      return data?.createOnboardingActivity?.onboardingActivity;
    },
    [createOnboardingActivity],
  );
};
